import DraggableTableItem from "./DraggableTableItem";

export default DraggableTableItem;
